import React, { useState } from 'react';
import {
  Button,
  QuoteFormWrapper,
  QuoteFormTitle,
  Form,
  FormError,
  FormGroup,
  FormGrid,
  FormIntro,
  HelpText,
  Label,
  Input,
  TextArea,
  RequiredNote,
} from './styled/quote.style';

const quoteEndpoint = process.env.REACT_APP_QUOTES_ENDPOINT || 'http://localhost:8000/quotes/';

const initialFormData = {
  CustName: '',
  CustEmail: '',
  CustPhone: '',
  JobLocation: '',
  JobDescription: '',
};

const QuoteForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setErrorMessage('');

    try {
      const response = await fetch(quoteEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Quote request failed');
      }

      if (response.headers?.get('content-type')?.includes('application/json')) {
        await response.json();
      }

      setFormData(initialFormData);
      setStatus('idle');
      onSubmit?.();
    } catch (error) {
      setStatus('error');
      setErrorMessage(
        'We could not submit the form right now. Please call or email KMK Drywall and we will help from there.'
      );
      console.error('Quote request error:', error);
    }
  };

  const isSubmitting = status === 'submitting';

  return (
    <QuoteFormWrapper>
      <QuoteFormTitle>Request a Quote</QuoteFormTitle>
      <FormIntro>
        Fill out the form below and KMK Drywall will follow up about drywall
        installation, finishing, framing, ceiling grid, or repair work.
      </FormIntro>
      <Form onSubmit={handleSubmit}>
        <FormGrid>
          <FormGroup>
            <Label htmlFor="CustName">Full name</Label>
            <Input
              autoComplete="name"
              id="CustName"
              name="CustName"
              onChange={handleChange}
              placeholder="Your name"
              required
              type="text"
              value={formData.CustName}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="CustEmail">Email address</Label>
            <Input
              autoComplete="email"
              id="CustEmail"
              name="CustEmail"
              onChange={handleChange}
              placeholder="you@example.com"
              required
              type="email"
              value={formData.CustEmail}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="CustPhone">Phone number</Label>
            <Input
              autoComplete="tel"
              id="CustPhone"
              name="CustPhone"
              onChange={handleChange}
              placeholder="(716) 555-0123"
              required
              type="tel"
              value={formData.CustPhone}
            />
          </FormGroup>
        </FormGrid>
        <FormGroup>
          <Label htmlFor="JobLocation">Job location</Label>
          <TextArea 
            id="JobLocation"
            name="JobLocation"
            onChange={handleChange}
            placeholder="Street, town, or general project area"
            required
            value={formData.JobLocation}
          />
          <HelpText>KMK Drywall serves Springville, Buffalo, Erie County, and Western New York.</HelpText>
        </FormGroup>
        <FormGroup>
          <Label htmlFor="JobDescription">Project details / message</Label>
          <TextArea
            id="JobDescription"
            name="JobDescription"
            onChange={handleChange}
            placeholder="Tell us what you need: drywall repair, finishing, hanging, framing, ceiling grid, project size, timeline, or any useful details."
            required
            value={formData.JobDescription}
          />
        </FormGroup>
        {errorMessage && <FormError role="alert">{errorMessage}</FormError>}
        <RequiredNote>All fields are required.</RequiredNote>
        <Button disabled={isSubmitting} type="submit">
          {isSubmitting ? 'Submitting...' : 'Submit Quote Request'}
        </Button>
      </Form>
    </QuoteFormWrapper>
  );
};

export default QuoteForm;
